import React from 'react';
import {
  Code2, Database, BarChart3, Table2, Layers, Calculator,
  LineChart, PieChart, Server, GitBranch, FileCode, Cloud
} from 'lucide-react';
import { toolsDetailed } from '../data/mock';

const iconComponents = {
  'code': Code2,
  'database': Database,
  'bar-chart': BarChart3,
  'table': Table2,
  'layers': Layers,
  'calculator': Calculator,
  'line-chart': LineChart,
  'pie-chart': PieChart,
  'server': Server,
  'git-branch': GitBranch,
  'file-code': FileCode,
  'cloud': Cloud
};

const TechStack = () => {
  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="mb-16">
          <span className="label-text text-[rgba(35,35,35,0.5)] mb-4 block">Technologies</span>
          <h2 className="section-title">Tech Stack</h2>
        </div>

        {/* Tools Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {toolsDetailed.map((tool, idx) => {
            const IconComponent = iconComponents[tool.icon] || Code2;
            return (
              <div
                key={idx}
                className="card-sharp p-4 group hover:bg-[#232323] transition-all duration-300"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="p-2 bg-[#38FF62] group-hover:bg-white transition-colors">
                    <IconComponent className="w-4 h-4 text-[#232323]" />
                  </div>
                  <div>
                    <h4 className="font-display text-sm font-semibold group-hover:text-white transition-colors">
                      {tool.name}
                    </h4>
                    <span className="font-mono text-[10px] uppercase text-[rgba(35,35,35,0.5)] group-hover:text-[rgba(255,255,255,0.5)] transition-colors">
                      {tool.category}
                    </span>
                  </div>
                </div>
                
                {/* Proficiency Bar */}
                <div className="h-1 bg-[rgba(35,35,35,0.1)] group-hover:bg-[rgba(255,255,255,0.1)] relative transition-colors">
                  <div
                    className="h-full bg-[#232323] group-hover:bg-[#38FF62] transition-all duration-500"
                    style={{ width: `${tool.proficiency}%` }}
                  />
                </div>
                <div className="flex justify-end mt-1">
                  <span className="font-mono text-[10px] text-[rgba(35,35,35,0.4)] group-hover:text-[rgba(255,255,255,0.4)] transition-colors">
                    {tool.proficiency}%
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TechStack;